import { AccountTree, ChevronRight, Dataset, PersonOutline } from '@mui/icons-material'
import { Card, CardActionArea, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ComposableNextLink } from '@omnea-app/fe-routing/InternalLinkButton'
import { Thumbnail } from '@omnea-app/omui/Thumbnail'
import { OrgConfigIssue, OrgConfigIssueKey } from '../../hooks/useOrgConfigIssuesBannerInfo'
import type { ReactElement } from 'react'

type IssuePresentation = {
  icon: ReactElement
  categoryKey: string
  titleKey: string
  affectedKey: string
}

const ISSUE_PRESENTATION: Record<OrgConfigIssueKey, IssuePresentation> = {
  'broken-workflows': {
    icon: <AccountTree />,
    categoryKey: 'broken-workflows.category',
    titleKey: 'broken-workflows.title',
    affectedKey: 'broken-workflows.affected',
  },
  'missing-assignees': {
    icon: <PersonOutline />,
    categoryKey: 'missing-assignees.category',
    titleKey: 'missing-assignees.title',
    affectedKey: 'missing-assignees.affected',
  },
  'archived-core-data': {
    icon: <Dataset />,
    categoryKey: 'archived-core-data.category',
    titleKey: 'archived-core-data.title',
    affectedKey: 'archived-core-data.affected',
  },
}

type Props = {
  issue: OrgConfigIssue
}

export const OrgConfigIssueRow = ({ issue }: Props) => {
  const { t } = useTranslation('common', { keyPrefix: 'org-config-issues' })
  const { icon, categoryKey, titleKey, affectedKey } = ISSUE_PRESENTATION[issue.key]

  return (
    <Card>
      <CardActionArea component={ComposableNextLink} to={issue.href} sx={{ p: 3 }}>
        <Stack direction="row" alignItems="center" gap={3}>
          <Thumbnail size="small" color={issue.severity}>
            {icon}
          </Thumbnail>
          <Stack flex={1} gap={0.5}>
            <Typography variant="small-regular" color="text.subtle">
              {t(categoryKey)}
            </Typography>
            <Typography variant="body-medium">{t(titleKey)}</Typography>
            <Typography variant="small-regular" color="text.subtle">
              {t(affectedKey, { count: issue.count })}
            </Typography>
          </Stack>
          <ChevronRight sx={{ color: 'fg.subtle' }} />
        </Stack>
      </CardActionArea>
    </Card>
  )
}
